import { Dataset, ErrorState, ListSearch, WorkflowV1Read } from '@ca/core/models';
import { createAction, props } from '@ngrx/store';

const segmentationWorkflowsPrefix = '[Segmentation Workflows]';
const trainingWorkflowsPrefix = '[Training Workflows]';
const datasetsPrefix = '[Datasets]';

export const loadSegmentationWorkflows = createAction(`${segmentationWorkflowsPrefix} Load`);
export const loadSegmentationWorkflowsSuccess = createAction(`${segmentationWorkflowsPrefix} Loaded`, props<{ segmentationWorkflows: WorkflowV1Read[] }>());
export const loadSegmentationWorkflowsFailed = createAction(`${segmentationWorkflowsPrefix} Load failed`, props<{ error: string }>());

export const loadTrainingWorkflows = createAction(`${trainingWorkflowsPrefix} Load`);
export const loadTrainingWorkflowsSuccess = createAction(`${trainingWorkflowsPrefix} Loaded`, props<{ trainingWorkflows: WorkflowV1Read[] }>());
export const loadTrainingWorkflowsFailed = createAction(`${trainingWorkflowsPrefix} Load failed`, props<{ error: string }>());

export const loadDatasets = createAction(`${datasetsPrefix} Load`, props<{ payload?: { searchParams: ListSearch } }>());
export const loadDatasetsSuccess = createAction(`${datasetsPrefix} Loaded`, props<{ datasets: Dataset[]; totalCount: number }>());
export const loadDatasetsFailed = createAction(`${datasetsPrefix} Load failed`, props<ErrorState>());
export const loadNumberOfAllDatasets = createAction(`${datasetsPrefix} Load Number of All Datasets`);
export const loadNumberOfAllDatasetsSuccess = createAction(`${datasetsPrefix} Number of All Datasets Loaded`, props<{ numberOfAllDatasets: number }>());
export const loadNumberOfAllDatasetsFailed = createAction(`${datasetsPrefix} Number of All Datasets Load failed`, props<ErrorState>());
